import { motion, AnimatePresence } from "framer-motion";
import { WarningOctagonIcon, BookOpenTextIcon, ArrowRightIcon } from "@phosphor-icons/react";
import { DecisionBadge } from "./DecisionBadge";

export const FeedbackModal = ({ open, result, redFlag, onNext, isLast }) => {
  if (!result) return null;
  return (
    <AnimatePresence>
      {open && (
        <motion.div
          className="fixed inset-0 z-50 flex items-center justify-center p-4"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          data-testid="feedback-modal"
        >
          <div className="absolute inset-0 bg-[#0a0a0a]/40 backdrop-blur-[6px]" />
          <motion.div
            initial={{ scale: 0.95, opacity: 0, y: 10 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.96, opacity: 0 }}
            transition={{ duration: 0.28, ease: [0.16, 1, 0.3, 1] }}
            className="relative w-full max-w-lg bg-white/85 backdrop-blur-xl border border-white/50 shadow-2xl"
            style={{ boxShadow: "0 0 0 1px rgba(225,29,72,0.35), 0 30px 80px -20px rgba(0,0,0,0.4)" }}
          >
            <div className="bg-[#e11d48] px-6 py-4 flex items-center gap-3">
              <WarningOctagonIcon size={26} weight="fill" color="#fff" />
              <div>
                <div className="label text-white/80 text-[0.6rem]">Compliance Alert</div>
                <div className="font-head font-black text-white text-xl tracking-tight leading-none">
                  Incorrect Determination
                </div>
              </div>
            </div>

            <div className="p-6 space-y-5">
              <div className="flex items-center gap-4">
                <div className="flex-1">
                  <div className="label mb-1.5">Your Choice</div>
                  <DecisionBadge decision={result.your_decision} size="lg" />
                </div>
                <ArrowRightIcon size={20} weight="bold" className="text-[#a3a3a3]" />
                <div className="flex-1">
                  <div className="label mb-1.5">Correct Choice</div>
                  <DecisionBadge decision={result.correct_decision} size="lg" />
                </div>
              </div>

              <div className="border border-[#e5e5e5] bg-[#f8f9fa]">
                <div className="flex items-center gap-2 px-4 py-2.5 border-b border-[#e5e5e5] bg-white">
                  <BookOpenTextIcon size={16} weight="bold" />
                  <span className="label text-[0.62rem]">{result.rule_reference}</span>
                </div>
                {redFlag && redFlag.flagged && (
                  <div className="px-4 pt-3.5">
                    <div className="text-[0.62rem] font-bold uppercase tracking-widest text-[#e11d48]">
                      🚩 {redFlag.category}
                    </div>
                    <p className="text-sm text-[#171717] leading-relaxed mt-1">
                      {redFlag.detail}
                    </p>
                  </div>
                )}
                <p
                  className="px-4 py-3.5 text-sm leading-relaxed text-[#171717]"
                  data-testid="feedback-reasoning"
                >
                  {result.reasoning}
                </p>
              </div>

              <button
                onClick={onNext}
                data-testid="feedback-next-btn"
                className="w-full bg-[#0a0a0a] text-white font-semibold py-3.5 flex items-center justify-center gap-2 hover:bg-[#262626] transition-colors"
              >
                {isLast ? "Finish Module" : "Next Claim"}
                <ArrowRightIcon size={17} weight="bold" />
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
